export default __webpack_public_path__ + "static/media/logo.2ee6c37e.svg";